import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon, TEXT_ALIGNMENT_OPTIONS, TextAlignmentOptions, Url } from '#const';
import { getIconUrl } from '#utils';

const ContactUs = dynamic(() => import('./ContactUs'));

export const defaultOptions = {
	heading: '<h1>Contact Us</h1>',
	headingAlignment: TextAlignmentOptions.LEFT,
	copy: "<p>If you became injured or seriously ill after using a product or service, \
                we can help. Please review our current cases section to see how we are \
                currently helping victims. If you don't see the case you're looking for or \
                have any other questions, please reach out via the form on this page. </p>",
	copyAlignment: TextAlignmentOptions.LEFT,
	image: Url.PLACEHOLDER_IMAGE,
	backgroundColor: '#F9FAFB',
} as const;

Builder.registerComponent(ContactUs, {
	name: 'ContactUs',
	inputs: [
		{
			name: 'heading',
			friendlyName: 'Heading',
			type: 'richText',
			defaultValue: defaultOptions.heading,
		},
		{
			name: 'headingAlignment',
			friendlyName: 'Heading Alignment',
			type: 'string',
			enum: [...TEXT_ALIGNMENT_OPTIONS],
			defaultValue: defaultOptions.headingAlignment,
		},
		{
			name: 'copy',
			friendlyName: 'Copy',
			type: 'richText',
			defaultValue: defaultOptions.copy,
		},
		{
			name: 'copyAlignment',
			friendlyName: 'Copy Alignment',
			type: 'string',
			enum: [...TEXT_ALIGNMENT_OPTIONS],
			defaultValue: defaultOptions.copyAlignment,
		},
		{
			name: 'image',
			friendlyName: 'Image',
			type: 'file',
			allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
			defaultValue: defaultOptions.image,
		},
		{
			name: 'backgroundColor',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: defaultOptions.backgroundColor,
		},
	],
	defaultChildren: [
		{
			'@type': '@builder.io/sdk:Element',
			component: {
				name: 'SingleForm',
				options: {
					showFinePrint: false,
					showLogos: true,
				},
			},
		},
	],
	childRequirements: {
		message: 'Child must be a SingleForm component',
		query: {
			'component.name': { $eq: 'SingleForm' },
		},
	},
	image: getIconUrl(Icon.FORM),
});
